import * as sagaEffects from 'redux-saga/effects';

import handleLocationChangeSaga from './handleChangeLocationSaga';

import handleSetNewPinSaga from './handleSetNewPinSaga';

import handleDragPinSaga from './handleDragPinSaga';

import handlePinsRequestSaga from './handlePinsRequestSaga';
import handlePinDetailRequestSaga from './handlePinDetailRequestSaga';
import handleAddPinRequestSaga from './handleAddPinRequestSaga';
import handleUpdatePinRequestSaga from './handleUpdatePinRequestSaga';
import handleDeletePinRequestSaga from './handleDeletePinRequestSaga';

const { all } = sagaEffects;

export default function* () {
    yield all([
        handleDragPinSaga(),
        handleSetNewPinSaga(),
        handlePinsRequestSaga(),
        handlePinDetailRequestSaga(),
        handleAddPinRequestSaga(),
        handleUpdatePinRequestSaga(),
        handleDeletePinRequestSaga(),
        handleLocationChangeSaga(),
    ]);
}
